export const LOCALE = process.env.NEXT_PUBLIC_LOCALE
export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const DY_BEARER = process.env.DY_BEARER === 'true'
export const DY_COOKIE_SESSION = 'DY_USER_NEXIA'
export const SEO_FALLBACK = {
  title: 'Nexia | Culture x Light',
  description: 'Creando espacios acogedores que conectan a las personas con la tecnología'
}

export const LANGUAGES = ['en', 'es', 'fr', 'it'] as const

export {
	autoComplete,
	copyToClipboard,
	downloadPDF,
	getDynamicText,
	getHttpClientErrorMessage,
	getHttpServerErrorMessage,
	parseSearchParams,
	slugify
} from '@digital-you/dy-warehouse/utils'

export * from './icon'

export * from './base'
export * from './project'
